import { useParams } from 'react-router-dom';
import { SubPageLayout } from '../../../../sub-page-layout.tsx';
import { TransactionsContainer } from '../components/transactions.container';
import { Helmet } from 'react-helmet';

export const TransactionsCredCase: React.FC = () => {
  const params = useParams();
  return (
    <div style={{ marginTop: '25px' }}>
      <Helmet>
        <title>Case - Transactions</title>
      </Helmet>
      <SubPageLayout title="Transaction Summary">
        <TransactionsContainer caseId={params['caseId'] ?? ''} />
      </SubPageLayout>
    </div>
  );
};
